/* eslint-disable global-require */
import CloseIcon from "@mui/icons-material/Close";
import {
  AppBar,
  Button,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import React, { useState } from "react";
import ConfirmationDialog from "../ConfirmationDialog";
import ExampleCard from "./ExampleCard";

function ExamplesButton(props) {
  const { onLoad } = props;

  // Constants
  const examples = [
    {
      name: "Lumi",
      cssPath: "assets/css/lumi.css",
      images: [
        require("../../assets/images/lumi.1.png"),
        require("../../assets/images/lumi.2.png"),
      ],
    },
    {
      name: "Matrix",
      cssPath: "assets/css/matrix.css",
      images: [
        require("../../assets/images/matrix.1.png"),
        require("../../assets/images/matrix.2.png"),
      ],
    },
    {
      name: "Prism",
      cssPath: "assets/css/prism.css",
      images: [
        require("../../assets/images/prism.1.png"),
        require("../../assets/images/prism.2.png"),
      ],
    },
    {
      name: "Typewriter",
      cssPath: "assets/css/typewriter.css",
      images: [
        require("../../assets/images/typewriter.1.png"),
        require("../../assets/images/typewriter.2.png"),
      ],
    },
  ];

  // States
  const [open, setOpen] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [selectedExample, setSelectedExample] = useState({});

  // Functions
  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = (example) => {
    setOpenConfirmation(true);
    setSelectedExample(example);
  };

  const handleAgree = () => {
    fetch(selectedExample.cssPath)
      .then((response) => response.text())
      .then((text) => onLoad(text));
    setOpenConfirmation(false);
    setOpen(false);
  };

  // Render
  return (
    <>
      <Dialog fullScreen open={open} onClose={handleClose}>
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h5" component="h1">
              Examples
            </Typography>

            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>

        <DialogContent dividers>
          <Grid container spacing={2}>
            {examples.map((example) => {
              return (
                <Grid key={example.name} size={{ xs: 12, lg: 6 }}>
                  <ExampleCard
                    example={example}
                    onClick={() => handleClick(example)}
                  />
                </Grid>
              );
            })}
          </Grid>
        </DialogContent>
      </Dialog>

      <ConfirmationDialog
        title="Are you sure you want to load this example?"
        text="Loading the example will replace your current code (You can use CTRL + Z inside the CSS editor to go back to your code)."
        onAgree={handleAgree}
        open={openConfirmation}
        onClose={() => setOpenConfirmation(false)}
      />

      <Button variant="contained" size="small" onClick={() => setOpen(true)}>
        Load Example
      </Button>
    </>
  );
}

ExamplesButton.propTypes = {
  onLoad: PropTypes.func.isRequired,
};

export default ExamplesButton;
